module.exports = __webpack_public_path__ + "img/p15.9cb6f82d.png";